export const Pages = {
    GlutenSensitivity1: {
        type: 'Question',
        text: 'What is your sensitivity to gluten?',
        subtext: 'This helps us provide more accurate recommendations for you',
        isMultipleChoice: false,
        allowSkip: true,
        answers: [
            {
                id: 'celiac',
                text: 'Celiac',
                ratio: 0.77,
                nextPageName: null,
                emojis: ['⚕️', '🔬', '📋', '✨', '💪']
            },
            {
                id: 'intolerant',
                text: 'Gluten intolerant',
                ratio: 0.16,
                nextPageName: null,
                emojis: ['⚕️', '🍽️', '✨', '💪', '🌟']
            },
            {
                id: 'choice',
                text: 'Gluten-free by choice',
                ratio: 0.04,
                nextPageName: null,
                emojis: ['🥗', '🥑', '🌱', '💚', '🧘']
            },
        ],
    },
    SafetyOfPlaces1: {
        type: 'Question',
        text: 'What type of places are you looking for?',
        subtext: null,
        isMultipleChoice: true,
        allowSkip: true,
        answers: [
            {
                id: 'dedicated',
                text: '100% GF places',
                ratio: 0.45,
                nextPageName: null,
                emojis: ['✅', '🔒', '💯', '🏆', '⭐']
            },
            {
                id: 'celiac_safe',
                text: 'Celiac-safe places',
                ratio: 0.35,
                nextPageName: null,
                emojis: ['⚕️', '🛡️', '✔️', '🔍', '💪']
            },
            {
                id: 'friendly',
                text: 'Gluten-free aware places',
                ratio: 0.20,
                nextPageName: null,
                emojis: ['🤝', '🍽️', '📝', '🌟', '✨']
            },
            {
                id: 'options',
                text: 'Places with GF options',
                ratio: 0.20,
                nextPageName: null,
                emojis: ['🤝', '🍽️', '📝', '🌟', '✨']
            },
        ],
    },
    GlutenSensitivity2: {
        type: 'Question',
        text: 'What symptoms do you typically experience with gluten?',
        isMultipleChoice: true,
        allowSkip: true,
        answers: [
            {
                id: 'digestive',
                text: 'Digestive issues',
                ratio: 0.68,
                nextPageName: null,
                emojis: ['⚕️', '💫', '🌿', '💊', '✨']
            },
            {
                id: 'fatigue',
                text: 'Fatigue and brain fog',
                ratio: 0.45,
                nextPageName: null,
                emojis: ['🌟', '💫', '🧠', '✨', '🌿']
            },
            {
                id: 'skin',
                text: 'Skin problems',
                ratio: 0.23,
                nextPageName: null,
                emojis: ['⚕️', '💫', '🧴', '✨', '🌿']
            },
            {
                id: 'headaches',
                text: 'Headaches and migraines',
                ratio: 0.31,
                nextPageName: null,
                emojis: ['⚕️', '💫', '🧠', '💊', '✨']
            }
        ],
    },
    WhatPlacesDoYouWant1: {
        type: 'Question',
        text: 'What places do you need the most help finding?',
        isMultipleChoice: true,
        allowSkip: true,
        answers: [
            {
                id: 'restaurants',
                text: 'Restaurants',
                ratio: 0.81,
                nextPageName: null,
                emojis: ['🍽️', '👨‍🍳', '🍳', '', '🍴']
            },
            {
                id: 'bars',
                text: 'Bars',
                ratio: 0.43,
                nextPageName: null,
                emojis: ['🍸', '🍹', '🍷', '🍺', '🎉']
            },
            {
                id: 'cafes',
                text: 'Cafes',
                ratio: 0.52,
                nextPageName: null,
                emojis: ['☕', '🫖', '🍵', '🧋', '🥐']
            },
            {
                id: 'bakery',
                text: 'Bakeries',
                ratio: 0.27,
                nextPageName: null,
                emojis: ['🥖', '🥯', '🥨', '🧁', '🍪']
            },
            {
                id: 'hotels',
                text: 'Hotels',
                ratio: 0.27,
                nextPageName: null,
                emojis: ['🥖', '🥯', '🥨', '🧁', '🍪']
            },
            {
                id: 'Grocerystgroceryores',
                text: 'Grocery Stores',
                ratio: 0.27,
                nextPageName: null,
                emojis: ['🥖', '🥯', '🥨', '🧁', '🍪']
            }

        ],
    },
    DietaryRestrictions: {
        type: 'Question',
        text: 'Got it!\nBesides gluten, do you have any other dietary restrictions?',
        isMultipleChoice: true,
        allowSkip: true,
        answers: [
            {
                id: 'dairy',
                text: "I'm dairy-free",
                ratio: 0.35,
                nextPageName: null,
                emojis: ['🥛', '🌱', '🥗', '✨', '🌿']
            },
            {
                id: 'vegan',
                text: "I'm vegan",
                ratio: 0.25,
                nextPageName: null,
                emojis: ['🌱', '🥗', '🥬', '🥕', '🌿']
            },
            {
                id: 'vegetarian',
                text: "I'm vegetarian",
                ratio: 0.32,
                nextPageName: null,
                emojis: ['🥜', '⚕️', '💫', '✨', '💊']
            },
            {
                id: 'allergen',
                text: "I eat an allergen-friendly diet",
                ratio: 0.12,
                nextPageName: null,
                emojis: ['🥜', '⚕️', '💫', '✨', '💊']
            },
            {
                id: 'none',
                text: 'No other restrictions',
                ratio: 0.49,
                nextPageName: null,
                emojis: ['✅', '👍', '🆗', '💯', '🙂']
            }
        ],
    },
    DiningPreference: {
        type: 'Question',
        text: 'What type of dining experience do you prefer?',
        isMultipleChoice: false,
        allowSkip: true,
        answers: [
            {
                id: 'casual',
                text: 'Casual dining',
                ratio: 0.45,
                nextPageName: null,
                emojis: ['🍽️', '☕', '🏡', '👕', '😊']
            },
            {
                id: 'fine',
                text: 'Fine dining',
                ratio: 0.25,
                nextPageName: null,
                emojis: ['🍷', '✨', '👔', '🕯️', '🎩']
            },
            {
                id: 'quick',
                text: 'Quick service',
                ratio: 0.30,
                nextPageName: null,
                emojis: ['⚡', '🏃', '🥪', '🥤', '⏱️']
            }
        ],
    },
    PriceRange: {
        type: 'Question',
        text: 'What is your preferred price range per meal?',
        isMultipleChoice: false,
        allowSkip: true,
        answers: [
            {
                id: 'budget',
                text: '$10-20',
                ratio: 0.35,
                nextPageName: null,
                emojis: ['💰', '💵', '️', '🤑', '💸']
            },
            {
                id: 'moderate',
                text: '$20-40',
                ratio: 0.40,
                nextPageName: null,
                emojis: ['💰', '💰', '💵', '💳', '🏷️']
            },
            {
                id: 'premium',
                text: '$40+',
                ratio: 0.25,
                nextPageName: null,
                emojis: ['💰', '💰', '💰', '💎', '💳']
            }
        ],
    },
    PreCheckout: {
        type: 'PreCheckout'
    },
    PreCheckoutImproved: {
        type: 'PreCheckoutImproved',
        bgColor: 'white',
    },
    AprilPricingPage: {
        type: 'AprilPricingPage',
        bgColor: 'white',
        hideHeader: true,
    },
    PaymentPageRedirect: {
        type: 'PaymentPageRedirect',
        bgColor: 'white',
        hideHeader: true,
    },
    InAppQuizResultsScreen: {
        type: 'InAppQuizResultsScreen',
        bgColor: 'white',
        hideHeader: true,
    },
    Statement230kPlaces: {
        type: 'Statement',
        allowSkip: false
    },
    Statement230kPlaces2: {
        type: 'Statement',
        allowSkip: false
    },
    Loading1: {
        type: 'Statement',
        allowSkip: false
    },
    PerfectFit1: {
        type: 'Statement',
        allowSkip: false
    },
    LoadingImproved: {
        type: 'LoadingImproved',
        allowSkip: false
    },
    LocationPreference: {
        type: 'Question',
        text: 'Where do you want help finding places?',
        isMultipleChoice: true,
        allowSkip: true,
        answers: [
            {
                id: 'home',
                text: 'Around my house',
                ratio: 0.71,
                nextPageName: null,
                emojis: ['🏠', '🏡', '📍', '🗺️', '🏘️']
            },
            {
                id: 'work',
                text: 'Around work',
                ratio: 0.31,
                nextPageName: null,
                emojis: ['💼', '🏢', '📍', '🗺️', '👔']
            },
            {
                id: 'travel',
                text: 'While travelling',
                ratio: 0.93,
                nextPageName: null,
                emojis: ['✈️', '🧳', '🗺️', '🌎', '📍']
            }
        ],
    },
    OccasionTypes: {
        type: 'Question',
        text: 'What occasions are you looking for places?',
        isMultipleChoice: true,
        allowSkip: true,
        answers: [
            {
                id: 'business',
                text: 'Business lunches',
                ratio: 0.25,
                nextPageName: null,
                emojis: ['💼', '🤝', '🍽️', '👔', '📊']
            },
            {
                id: 'date',
                text: 'Date nights',
                ratio: 0.63,
                nextPageName: null,
                emojis: ['💑', '🌙', '💕', '🍷', '✨']
            },
            {
                id: 'friends',
                text: 'Lunch with friends',
                ratio: 0.76,
                nextPageName: null,
                emojis: ['👥', '🤗', '🍽️', '😊', '🎉']
            },
            {
                id: 'family',
                text: 'Family dinners',
                ratio: 0.68,
                nextPageName: null,
                emojis: ['👨‍👩‍👧‍👦', '🏠', '🍽️', '❤️', '🌟']
            }
        ],
    },
    WebsiteHopping: {
        type: 'Question',
        text: 'Do you hop between different sites to find places?',
        isMultipleChoice: false,
        allowSkip: true,
        answers: [
            {
                id: 'yes',
                text: 'Yes',
                ratio: 0.82,
                nextPageName: null,
                emojis: ['🔄', '💻', '🔍', '📱', '✅']
            },
            {
                id: 'no',
                text: 'No',
                ratio: 0.18,
                nextPageName: null,
                emojis: ['📱', '💻', '✨', '💫', '😌']
            }
        ],
    },
    CommunityParticipation: {
        type: 'Question',
        text: 'Do you want to participate in our community?',
        isMultipleChoice: false,
        allowSkip: true,
        answers: [
            {
                id: 'yes',
                text: 'Yes',
                ratio: 0.75,
                nextPageName: null,
                emojis: ['👥', '🤝', '💪', '🌟', '✨']
            },
            {
                id: 'no',
                text: 'No',
                ratio: 0.25,
                nextPageName: null,
                emojis: ['👥', '💫', '✨', '😊', '👋']
            }
        ],
    },
    CommunityMap: {
        type: 'Question',
        text: 'Do you want to checkout the gluten-free community map?',
        isMultipleChoice: false,
        allowSkip: false,
        answers: [
            {
                id: 'yes',
                text: 'Yes',
                ratio: 0.95,
                nextPageName: null,
                emojis: ['🗺️', '📍', '👥', '🔍', '🤝']
            },
            {
                id: 'no',
                text: 'No',
                ratio: 0.05,
                nextPageName: null,
                emojis: ['💫', '✨', '👋', '😊', '📍']
            }
        ],
    },
    PlacesStatement: {
        type: 'Statement'
    },
    TagsStatement: {
        type: 'Statement',
        text: "We have many filters to help you find the perfect place you're looking for",
        allowSkip: false
    },
    EmailScreen1: {
        type: 'Email',
        text: "Let's get you in!",
        emailType: 'email',
        savedEmail: '',
        savedPassword: '',
        allowSkip: false
    },
    EmailScreen2: {
        type: 'Email',
        text: "Sign up to start your gluten-free journey with Atly",
        emailType: 'email',
        savedEmail: '',
        savedPassword: '',
        allowSkip: false
    },
    EmailScreen3: {
        type: 'Email',
        text: "Almost ready! \nLet's save your preferences",
        emailType: 'email',
        savedEmail: '',
        savedPassword: '',
        allowSkip: false
    },
    SearchTarget: {
        type: 'Question',
        text: "Great! Let's set you up.\nWho are you finding \ngluten-free places for?",
        isMultipleChoice: false,
        allowSkip: true,
        answers: [
            {
                id: 'self',
                text: 'Myself',
                ratio: 0.63,
                nextPageName: null,
                emojis: ['🙋', '😊', '🍽️', '💪', '✨']
            },
            {
                id: 'sondaughter',
                text: 'My child',
                ratio: 0.28,
                nextPageName: null,
                emojis: ['👨‍👩‍👧‍👦', '❤️', '🏠', '🍽️', '🤗']
            },
            {
                id: 'spouse',
                text: 'My spouse',
                ratio: 0.28,
                nextPageName: null,
                emojis: ['👨‍👩‍👧‍👦', '❤️', '🏠', '🍽️', '🤗']
            },
            {
                id: 'friend',
                text: 'A friend',
                ratio: 0.09,
                nextPageName: null,
                emojis: ['👥', '🤝', '🎉', '🍽️', '😊']
            }
            ,
            {
                id: 'someone',
                text: 'Someone else',
                ratio: 0.09,
                nextPageName: null,
                emojis: ['👥', '🤝', '🎉', '🍽️', '😊']
            }
        ],
    },
    DiningChallenges: {
        type: 'Question',
        text: 'What makes dining out easier for you?',
        isMultipleChoice: false,
        allowSkip: true,
        answers: [
            {
                id: 'trained',
                text: 'Ordering from trained staff',
                ratio: 0.15,
                nextPageName: null,
                emojis: ['👨‍🍳', '🏆', '✅', '💪', '🔒']
            },
            {
                id: 'trust',
                text: 'Knowing the safe places',
                ratio: 0.53,
                nextPageName: null,
                emojis: ['✅', '🏆', '💪', '🔒', '💯']
            },
            {
                id: 'variety',
                text: 'More gluten-free options',
                ratio: 0.32,
                nextPageName: null,
                emojis: ['🔍', '🗺️', '🍽️', '✨', '🎯']
            }
        ],
    },
    SafetyRankingPreference: {
        type: 'Question',
        text: 'What matters most to you when checking if a place is safe?',
        isMultipleChoice: false,
        allowSkip: true,
        answers: [
            {
                id: 'cross_contamination',
                text: 'Cross-contamination protocols',
                ratio: 0.45,
                nextPageName: null,
                emojis: ['🔍', '⚕️', '✅', '🏥', '🛡️']
            },
            {
                id: 'dedicated',
                text: 'Dedicated gluten-free space',
                ratio: 0.30,
                nextPageName: null,
                emojis: ['🏠', '✨', '🔒', '💯', '🍽️']
            },
            {
                id: 'staff_knowledge',
                text: 'Staff knowledge and training',
                ratio: 0.25,
                nextPageName: null,
                emojis: ['👩‍🍳', '📚', '🎓', '💪', '🤝']
            }
        ],
    },
    SafetyRankingStatement: {
        type: 'Statement',
        allowSkip: false
    },
    CommunityValidationStatement: {
        type: 'Statement',
        allowSkip: false
    },
    GlobalCoverageStatement: {
        type: 'Statement',
        allowSkip: false
    },
    AggregatedInfoStatement: {
        type: 'Statement',
        allowSkip: false
    },
    DietitianStatement: {
        type: 'Statement',
        allowSkip: false
    },
    RealtimeUpdatesStatement: {
        type: 'Statement',
        allowSkip: false
    },
    CrossContaminationStatement: {
        type: 'Statement',
        allowSkip: false
    },
    TravelFeaturesStatement: {
        type: 'Statement',
        allowSkip: false
    },
    FeaturePreference: {
        type: 'Question',
        text: 'Which would be most helpful for you?',
        isMultipleChoice: false,
        allowSkip: true,
        answers: [
            {
                id: 'always',
                text: 'Places ranked by safety',
                ratio: 0.72,
                nextPageName: null,
                emojis: ['🔍', '📱', '😓', '⏰', '💭']
            },
            {
                id: 'sometimes',
                text: 'More reviews',
                ratio: 0.18,
                nextPageName: null,
                emojis: ['🤔', '⚖️', '🔍', '📱', '💫']
            },
            {
                id: 'rarely',
                text: 'Larger map',
                ratio: 0.10,
                nextPageName: null,
                emojis: ['✨', '💪', '😌', '✅', '🎯']
            }
        ],
    },
    AtlyIntro1: {
        type: 'Statement',
        allowSkip: false,
        text: "Welcome to Atly"
    },
    SafetyRankingExplanation: {
        type: 'Statement',
        allowSkip: false
    },
    InformationSources: {
        type: 'Question',
        text: 'Where do you typically look for gluten-free information?',
        isMultipleChoice: true,
        allowSkip: true,
        answers: [
            {
                id: 'google_search',
                text: 'Google',
                ratio: 0.89,
                nextPageName: null,
                emojis: ['🔍', '💻', '🌐', '📱', '🔎']
            },
            {
                id: 'yelp',
                text: 'Yelp',
                ratio: 0.65,
                nextPageName: null,
                emojis: ['⭐', '📝', '🍽️', '📱', '💬']
            },
            {
                id: 'tripadvisor',
                text: 'TripAdvisor',
                ratio: 0.43,
                nextPageName: null,
                emojis: ['✈️', '🌍', '📝', '🏨', '⭐']
            },
            {
                id: 'other',
                text: 'Other Sources',
                ratio: 0.21,
                nextPageName: null,
                emojis: ['📚', '💭', '🔍', '📱', '💡']
            }
        ],
    },
    ReviewAggregationStatement: {
        type: 'Statement',
        allowSkip: false
    },
    InformationAccuracyQuestion: {
        type: 'Question',
        text: 'How often do you encounter outdated or incorrect gluten-free information?',
        isMultipleChoice: false,
        allowSkip: true,
        answers: [
            {
                id: 'frequently',
                text: 'Frequently',
                ratio: 0.46,
                nextPageName: null,
                emojis: ['😓', '❌', '📱', '🔍', '⏰']
            },
            {
                id: 'sometimes',
                text: 'Sometimes',
                ratio: 0.40,
                nextPageName: null,
                emojis: ['🤔', '⚖️', '🔍', '📱', '⏳']
            },
            {
                id: 'rarely',
                text: 'Rarely',
                ratio: 0.13,
                nextPageName: null,
                emojis: ['✨', '✅', '😌', '💪', '🎯']
            },
            {
                id: 'never',
                text: 'Never',
                ratio: 0.01,
                nextPageName: null,
                emojis: ['✨', '✅', '😌', '💪', '🎯']
            }
        ],
    },
    InformationUpdateStatement: {
        type: 'Statement',
        text: "We have a dedicated team working alongside our community to maintain the most up-to-date and accurate gluten-free platform available. Our real-time updates and verification system ensure you always have reliable information.",
        allowSkip: false
    },
    SafetyCommitmentStatement: {
        type: 'Statement',
        text: "While we strive for perfection, we believe in being transparent. Mistakes can happen, but our commitment to your safety is unwavering. We continuously work with our community and experts to identify and correct any inaccuracies quickly.",
        allowSkip: false
    },
    BiggestStruggles1: {
        type: 'Question',
        text: 'What do you want to achieve with Atly?',
        subtext: 'Pick up to 3',
        isMultipleChoice: true,
        maxSelections: 3,
        allowSkip: true,
        answers: [
            {
                id: 'finding_places',
                text: 'Find places easily',
                ratio: 0.85,
                nextPageName: null,
                emojis: ['🔍', '🗺️', '📱', '🏪', '✨']
            },
            {
                id: 'confidence',
                text: 'Eat with confidence',
                ratio: 0.72,
                nextPageName: null,
                emojis: ['💪', '✅', '🛡️', '😌', '🎯']
            },
            {
                id: 'ordering',
                text: 'Know what to order',
                ratio: 0.65,
                nextPageName: null,
                emojis: ['📝', '🍽️', '🤔', '✔️', '📋']
            },
            {
                id: 'menus',
                text: 'Find GF menus',
                ratio: 0.58,
                nextPageName: null,
                emojis: ['📜', '🔍', '📱', '✨', '🍽️']
            },
            {
                id: 'safety',
                text: 'Understand the safety of a place',
                ratio: 0.78,
                nextPageName: null,
                emojis: ['🛡️', '⚕️', '✅', '🔒', '💪']
            }
        ],
    },
    WhereDoYouWantPlaces: {
        type: 'Question',
        text: 'Where do you want to find gluten-free places?',
        isMultipleChoice: true,
        allowSkip: true,
        answers: [
            {
                id: 'neighborhood',
                text: '{neighborhood}',
                ratio: 0.45,
                nextPageName: null,
                emojis: ['🏘️', '📍', '🗺️', '🏡', '✨']
            },
            {
                id: 'city',
                text: '{city}',
                ratio: 0.35,
                nextPageName: null,
                emojis: ['🏙️', '📍', '🌆', '🌃', '✨']
            },
            {
                id: 'region',
                text: '{region}',
                ratio: 0.15,
                nextPageName: null,
                emojis: ['🗺️', '📍', '🌎', '🏛️', '✨']
            },
            {
                id: 'country',
                text: '{country}',
                ratio: 0.05,
                nextPageName: null,
                emojis: ['🌎', '🌍', '🌏', '✈️', '🗺️']
            },
            {
                id: 'worldwide',
                text: 'Worldwide',
                ratio: 0.05,
                nextPageName: null,
                emojis: ['🌎', '🌍', '🌏', '✈️', '🗺️']
            }
        ],
    }
};